import React, { useState } from "react"
import { Button, Col, Icon, Row, Typography } from "antd"
import { graphql, useStaticQuery } from "gatsby"
import WRPSearch from "../WRPSearch/WRPSearch"
import ButtonModal from "../ButtonModal/ButtonModal"
import OptInModal from "../Forms/OptInModal"
import { prettifyPhoneNumber } from "../../utils/phoneNumbers"
import style from "./BookingBar.module.scss"

const checkAvailRowProps = {
  align: `middle`,
  className: style.checkAvailRow,
  justify: `center`,
  type: `flex`,
}

const emailCallRowProps = {
  align: "middle",
  className: style.emailCallRow,
  // justify: "space-around",
  justify: `center`,
  type: "flex",
}

const checkAvailColProps = {
  className: style.checkAvailCol,
  xs: 22,
  md: 20,
  lg: 18,
  xl: 16,
}

const getOffersColProps = {
  className: style.emailCol,
  xs: 11,
  sm: 10,
  md: 9,
  lg: 8,
  xl: 6,
}

const callTodayColProps = {
  className: style.callCol,
  xs: 11,
  sm: 10,
  md: 9,
  lg: 8,
  xl: 6,
}

const checkAvailTitleProps = {
  className: style.checkAvailTitle,
  level: 2,
}

export default props => {
  const data = useStaticQuery(graphql`
    query {
      contact: contentfulHotel(name: { eq: "Lakeside Lodge Clemson" }) {
        phone
      }
      modalImg: contentfulAsset(
        contentful_id: { eq: "1ZEM3oX1jiSYkLndAnWeil" }
      ) {
        description
        fluid(maxWidth: 520) {
          ...fluid_withWebp_tracedSVG
        }
      }
    }
  `)

  const { contact, modalImg } = data
  const phone = prettifyPhoneNumber(contact.phone)

  const [vis, setVis] = useState(false)

  const showCTAButtons = props.showCTAButtons === false ? false : true

  return (
    <div id="booking-bar">
      {/* Booking Engine Form */}
      <Row {...checkAvailRowProps}>
        <Col {...checkAvailColProps}>
          <Typography.Title {...checkAvailTitleProps}>
            Book Your Room Today
          </Typography.Title>
          <WRPSearch hotelID={process.env.WRP_HOTEL_ID} phone={phone} />
        </Col>
      </Row>
      {/* CTA Buttons (unless showCTAButtons is explicitly set to false) */}
      {showCTAButtons ? (
        <Row {...emailCallRowProps}>
          {/* Email Offers */}
          <Col {...getOffersColProps}>
            <ButtonModal
              cta="Get Email Offers"
              image={modalImg}
              title="Be An Insider."
              body={
                <>
                  <Typography.Paragraph>
                    Sign up to have exclusive savings and offers,{" "}
                    <strong>
                      including 24 hours of early access to reservations on game
                      day weekends
                    </strong>
                    , delivered right to your email inbox! Unsubscribe any time!
                  </Typography.Paragraph>
                  <OptInModal
                    automationId={36}
                    formName="Email Offers"
                    gtmClickId="get-email-offers-form"
                    cancelText="Nevermind"
                    submitText="Sign Up!"
                    toggleModal={() => {
                      setVis(!vis)
                    }}
                  />
                </>
              }
              hideButtons={true}
              visible={vis}
              toggleModal={() => {
                setVis(!vis)
              }}
            />
          </Col>
          {/* Call Today */}
          <Col {...callTodayColProps}>
            <a className="click-to-call" href={`tel:${phone}`}>
              <Button size="large">
                <span>
                  <Icon type="phone" />
                  {phone}
                </span>
              </Button>
            </a>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </div>
  )
}
